import * as THREE from "three";

type ApplyMaterialParams = {
  model: THREE.Group;
  materialId: string | undefined;
  target: string;
  findNodesByName: (name: string) => THREE.Object3D[];
  onMaterialCloned?: (material: THREE.Material) => void;
};

export function applyMaterial(params: ApplyMaterialParams): void {
  const { model, materialId, target, findNodesByName, onMaterialCloned } =
    params;
  if (!model || !materialId || !target) return;

  const targetNodes = findNodesByName(target);
  const isMesh = materialId === "mesh";

  for (const node of targetNodes) {
    if (!(node instanceof THREE.Mesh)) continue;

    const mesh = node as THREE.Mesh<
      THREE.BufferGeometry,
      THREE.Material | THREE.Material[]
    >;
    const material = mesh.material;
    if (!material) continue;

    mesh.material = Array.isArray(material)
      ? material.map((item) =>
          cloneOpacityMaterial(item, isMesh, onMaterialCloned),
        )
      : cloneOpacityMaterial(material, isMesh, onMaterialCloned);
  }
}

function cloneOpacityMaterial(
  material: THREE.Material,
  isTransparent: boolean,
  onMaterialCloned?: (material: THREE.Material) => void,
): THREE.Material {
  if (
    material instanceof THREE.MeshStandardMaterial ||
    material instanceof THREE.MeshPhysicalMaterial
  ) {
    const cloned = material.clone();
    cloned.transparent = isTransparent;
    cloned.opacity = isTransparent ? 0.5 : 1;
    cloned.needsUpdate = true;
    onMaterialCloned?.(cloned);
    return cloned;
  }

  return material;
}
